import { reconcileTradeEntities } from '../../../../core/internal/trade-entity-reconcile.js';
import { hashDiagnosticEntity } from '../../../../tx-engine/diagnostics/lifecycle.js';
import type {
  TradeEntityReconciliationTarget,
  TradeMutationDeps,
  TradeMutationResult,
} from '../types.js';

/** Fire-and-report settlement reconciliation from the shared SDK mutation so
 * web and mobile cannot drift on which successful trade legs are covered. */
export function reconcileSettledTradeEntities(
  deps: TradeMutationDeps,
  result: TradeMutationResult | undefined,
): void {
  const targets =
    result?.tradeEntityTargets ??
    (result?.ok === true && result.signature.length > 0
      ? [{ signature: result.signature, expectedEventCount: 1 }]
      : []);
  reconcileTradeEntityTargets(deps, targets);
}

export function reconcileTradeEntityTargets(
  deps: TradeMutationDeps,
  targets: readonly TradeEntityReconciliationTarget[],
): void {
  if (targets.length === 0) return;

  void reconcileTradeEntities(deps.queryClient, targets)
    .then((reconciliation) => {
      if (reconciliation.status !== 'pending') return;
      deps.logger.warn('trade.entity_reconciliation_pending', {
        signatureSetHash: hashDiagnosticEntity(
          reconciliation.pendingSignatures.slice().sort().join(','),
        ),
        pendingSignatureCount: reconciliation.pendingSignatures.length,
        attempts: reconciliation.attempts,
      });
    })
    .catch((error: unknown) => {
      deps.logger.warn('trade.entity_reconciliation_failed', {
        signatureSetHash: hashDiagnosticEntity(
          targets
            .map((target) => target.signature)
            .sort()
            .join(','),
        ),
        errorClass: error instanceof Error ? error.name : typeof error,
      });
    });
}
